import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=184f5290&scoped=true&"
import script from "./PageLayout.vue?vue&type=script&lang=js&"
export * from "./PageLayout.vue?vue&type=script&lang=js&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=184f5290&prod&lang=scss&scoped=true&"
import style1 from "./PageLayout.vue?vue&type=style&index=1&id=184f5290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f5290",
  null
  
)

export default component.exports